// Get Codes Collections Scroll
export const GET_CODES_COLLECTIONS_SCROLL_REQUEST = 'GET_CODES_COLLECTIONS_SCROLL_REQUEST';
export const GET_CODES_COLLECTIONS_SCROLL_DONE = 'GET_CODES_COLLECTIONS_SCROLL_DONE';
export const GET_CODES_COLLECTIONS_SCROLL_FAILED = 'GET_CODES_COLLECTIONS_SCROLL_FAILED';
export const GET_CODES_COLLECTIONS_SCROLL_RESET = 'GET_CODES_COLLECTIONS_SCROLL_RESET';

export const CODES_COLLECTIONS_SCROLL_OPTIMISTIC_REMOVE = 'CODES_COLLECTIONS_SCROLL_OPTIMISTIC_REMOVE';
export const CODES_COLLECTIONS_SCROLL_OPTIMISTIC_ADD = 'CODES_COLLECTIONS_SCROLL_OPTIMISTIC_ADD';

// Operations
export const TOGGLE_CODES_COLLECTIONS_SCROLL = 'TOGGLE_CODES_COLLECTIONS_SCROLL';
export const TOGGLE_ALL_CODES_COLLECTIONS_SCROLL = 'TOGGLE_ALL_CODES_COLLECTIONS_SCROLL';
export const SET_CODES_COLLECTIONS_SCROLL_FILTER = 'SET_CODES_COLLECTIONS_SCROLL_FILTER';
export const SET_CODES_COLLECTIONS_SCROLL_ALL_FILTERS = 'SET_CODES_COLLECTIONS_SCROLL_ALL_FILTERS';
export const CLEAR_CODES_COLLECTIONS_SCROLL_FILTERS = 'CLEAR_CODES_COLLECTIONS_SCROLL_FILTERS';
export const CODES_COLLECTIONS_SCROLL_SET_PAGE_URL = 'CODES_COLLECTIONS_SCROLL_SET_PAGE_URL';
